import { render, staticRenderFns } from "./ShareSocial.vue?vue&type=template&id=1d1cc67c&"
import script from "./ShareSocial.vue?vue&type=script&lang=js&"
export * from "./ShareSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports